module.exports = require('./components/Modal');




//////////////////
// WEBPACK FOOTER
// /builds/development/frontend/widgets/widgets/node_modules/react-modal/lib/index.js
// module id = ../../node_modules/react-modal/lib/index.js
// module chunks = widget-7.1.6